import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Home = () => {
  const { t } = useLanguage();

  return (
    <>
      <div className="hero-section text-center">
        <Container>
          <h1 className="display-3 mb-4">{t('home.welcome')}</h1>
          <p className="lead mb-5">{t('home.subtitle')}</p>
          <Button as={Link} to="/products" variant="light" size="lg">
            {t('home.viewProducts')}
          </Button>
        </Container>
      </div>
      <Container>
        <div className="text-center py-5">
          <h2>{t('home.aboutTitle')}</h2>
          <p className="lead">
            {t('home.aboutText')}
          </p>
        </div>
      </Container>
    </>
  );
};

export default Home;
